import {
  useRelationDisplayValue,
  useRelationTargetStoreProvider,
} from '../properties/relation/display-resolver';

interface RelationGroupLabelProps {
  rowId: string;
  targetDatabaseId: string;
  targetFieldId: string;
}

export const RelationGroupLabel = ({
  rowId,
  targetDatabaseId,
  targetFieldId,
}: RelationGroupLabelProps) => {
  const targetStoreProvider = useRelationTargetStoreProvider();
  const title = useRelationDisplayValue({
    targetStoreProvider,
    rowId,
    targetDatabaseId,
    targetFieldId,
  });

  return <span>{title}</span>;
};
